import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';

import * as S from './styled';
import './slick.css';
import './slick-theme.css';

const CustomSlide = ({ temp, icon, date }, index, isCelsius) => {
  const { t } = useTranslation();

  const currentTemp = isCelsius ? temp : (temp * 9) / 5 + 35;

  const DayDate = new Date(date);
  const day = DayDate.getDay();
  const StringDate = `${DayDate.getDate()}.${DayDate.getMonth() + 1}.${DayDate.getFullYear()}`;

  return (
    <S.WeatherCard key={index}>
      <S.Day>{`${t(`day.${day}`)}`}</S.Day>
      <br />
      <S.Day>{StringDate}</S.Day>
      <S.CardBody>
        <S.Temperature>{`${Math.round(currentTemp)}°`}</S.Temperature>
        <S.WeatherImg src={`https://www.weatherbit.io/static/img/icons/${icon}.png`} />
      </S.CardBody>
    </S.WeatherCard>
  );
};

const SimpleSlider = ({ fifteenWeather, isCelsius }) => {
  const refSlider = useRef(null);
  useEffect(() => {
    refSlider.current.slickGoTo(0);
  }, [fifteenWeather]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
          dots: false,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };
  return (
    <Slider ref={refSlider} {...settings}>
      {fifteenWeather.map((item, index) => CustomSlide(item, index, isCelsius))}
    </Slider>
  );
};

export default SimpleSlider;

SimpleSlider.defaultProps = {
  fifteenWeather: null,
};

SimpleSlider.propTypes = {
  fifteenWeather: PropTypes.arrayOf(
    PropTypes.shape({
      temp: PropTypes.number,
      icon: PropTypes.string,
      date: PropTypes.string,
    })
  ),
  isCelsius: PropTypes.bool.isRequired,
};

CustomSlide.propTypes = {
  temp: PropTypes.number.isRequired,
  icon: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};
